import { Settings as SettingsIcon } from '@mui/icons-material';
import ApiIcon from '@mui/icons-material/Api';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { handleSignOut, useAuthenticator, useLazyQuery } from '@parkchirp/api-client';
import NextLink from 'next/link';
import React from 'react';
import { useCookies } from 'react-cookie';
import { AccessControlledLink } from '~/components/AccessControl';
import { AccessControlledComponents } from '~/constants';

import { GET_GITBOOK_JWT } from '../../queries/searchTypeQueries';

const RightSideHeader = () => {
	const [cookies, , removeCookie] = useCookies();
	const { authStatus } = useAuthenticator();
	const theme: any = useTheme();
	const isAuthenticated = authStatus === 'authenticated';
	const [fetchJWT] = useLazyQuery(GET_GITBOOK_JWT, {
		context: {
			apiVersion: 'v2',
		},
	});

	return (
		<div id='pca__detail-header-settings_link' style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
			<IconButton
				style={{ padding: '0px', marginTop: '8px', color: theme.title.color }}
				data-cy='settings-icon'
				size='small'
			>
				<AccessControlledLink componentName={AccessControlledComponents.SettingsGear} href='/settings/'>
					<SettingsIcon style={{ fontSize: '28px' }} data-cy='org-settings-icon' />
				</AccessControlledLink>
			</IconButton>
			<Tooltip title='API Docs' arrow>
				<IconButton style={{ padding: '0px', marginTop: '8px', color: theme.title.color }} size='small'>
					<NextLink href='/apiDocs'>
						<ApiIcon style={{ fontSize: '28px' }} />
					</NextLink>
				</IconButton>
			</Tooltip>
			<Tooltip title='View Docs' arrow>
				<span>
					<IconButton
						style={{ padding: '0px', color: theme.title.color }}
						size='small'
						onClick={async () => {
							const result = await fetchJWT();
							const { token } = result?.data?.getGitbookJWT || '';
							window.open(`${process.env.NEXT_PUBLIC_GITBOOK_URL}/?jwt_token=${token}`);
						}}
						data-cy='docs-icon'
					>
						<MenuBookOutlinedIcon style={{ fontSize: '30px', marginTop: '0px' }} />
					</IconButton>
				</span>
			</Tooltip>
			{isAuthenticated && (
				<Tooltip title='Sign Out' arrow>
					<span>
						<IconButton
							style={{ padding: '0px', color: theme.title.color }}
							size='small'
							onClick={() =>
								handleSignOut({
									cookies,
									removeCookie,
									UserPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOL_ID,
									ClientId: process.env.NEXT_PUBLIC_AWS_APP_CLIENT_ID,
									URL: process.env.NEXT_PUBLIC_MONTHLY_URL,
								})
							}
							data-cy='sign-out-icon'
						>
							<LogoutOutlinedIcon style={{ fontSize: '30px', marginTop: '0px' }} />
						</IconButton>
					</span>
				</Tooltip>
			)}
		</div>
	);
};

export default RightSideHeader;
